import MyProfileSettings from '../../container/account-info/index';
import wrapper from '../../redux';

const index = () => <MyProfileSettings />;

export const getServerSideProps = wrapper.getServerSideProps(() => async () => ({
  props: {
    footer: { hide: false },
  },
}));

export default index;
